import * as types from "./actions";
import { MAX_LONG } from "../../../../utils/constants";

const defaultState = {
    list: [],
    tableHeader: [
        {
            label: "商品分類名",
            button: false
        },
        {
            label: "商品コード",
            button: false,
            rightAlign: true,
            headerClass: "table-idResponsive"
        },
        {
            label: "商品名１",
            button: false
        },
        {
            label: "商品名２",
            button: false
        },
        {
            label: "編集",
            button: true
        },
        {
            label: "コピー",
            button: true
        }
    ],
    tableColumns: [
        "productClassName",
        "strProductCode",
        "productName1",
        "productName2",
    ],
    form: [
        {
            type: "number",
            label: "商品コード",
            placeholder: "",
            max: MAX_LONG,
            name: "productCode",
            required: true,
            disabled: false,
            readOnly: true
        }, {
            type: "text",
            label: "商品名１",
            placeholder: "",
            minLength: 1,
            maxLength: 40,
            name: "productName1",
            required: true,
            disabled: false
        }, {
            type: "text",
            label: "商品名２",
            placeholder: "",
            minLength: 1,
            maxLength: 40,
            name: "productName2",
            disabled: false
        },
        {
            type: "text",
            label: "フリガナ",
            placeholder: "",
            minLength: 1,
            maxLength: 20,
            name: "productKana",
            disabled: false
        },
        {
            componentClass: "select",
            type: "select",
            label: "商品分類",
            placeholder: "<< 商品分類を選択してください >>",
            name: "productClassCode",
            required: true,
            disabled: false
        }
    ]
}

export default function reducer(state = defaultState, action) {
    switch (action.type) {
        case types.LIST:
            return { ...state, list: action.payload };
        default: // need this for default case
            return state;
    }
};
